import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar.jsx";
import AboutPage from "./pages/About.jsx";
import ContactPage from "./pages/Contactus.jsx";
import HomePage from "./pages/Hoempage.jsx"; // Assuming the typo is intentional
import TeamsPage from "./pages/Teams.jsx";
import ContactPage2 from "./pages/Contactus2.jsx";
import ServicesPage from "./pages/services.jsx";
import ServicesPage2 from "./pages/services2.jsx";
import Footer from "./Components/Footer.jsx";
import NotFoundPage from "./Components/404.jsx";
import Webdevblog from "./blogs/webdev.jsx";
import AppDevelopmentServices from "./blogs/Appdev.jsx";
import DigitalStrategyPage from "./blogs/Digital-Strategy.jsx";
import PartnershipPage from "./pages/partner.jsx";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<>
          <HomePage />
          <AboutPage />
          <ServicesPage />
          <TeamsPage />
          <ContactPage />
          <PartnershipPage />
        </>} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/Services" element={<ServicesPage2 />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/contact" element={<ContactPage2 />} />
        <Route path="/web-development" element={<Webdevblog />} />
        <Route path="/app-development" element={<AppDevelopmentServices />} />
        <Route path="/Digital-Strategy" element={<DigitalStrategyPage />} />
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
